export default __webpack_public_path__ + "static/media/twitterWhite.ca9f60d6.svg";